import hljs from 'highlight.js';
import cobol from 'highlightjs-cobol';

// The default highlight.js browser bundle contains only common languages.
// Quill can request COBOL through the editor language picker, so register it
// explicitly before either the editor or the post renderer uses hljs.
if (!hljs.getLanguage('cobol')) {
  hljs.registerLanguage('cobol', cobol);
}

export default hljs;